import React from 'react';
import './App.css'
import { Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import Navigation from './container/Navigation';
import Acceuil from './container/Accueil';
import Tarifs from './container/Tarifs';
import Apropos from './container/Apropos';
import Reflexologie from './container/Reflexologie';
import Contact from './container/Contact';
import CookieBanner from './components/CookieBanner';
import './cookieconsent.css';






function App() {

  return (
    <div className="App">
      <Navigation />
      <CookieBanner />
      <Switch>
        <Route exact path='/' component={Acceuil} />
        <Route path='/apropos' component={Apropos} />
        <Route path='/reflexologie' component={Reflexologie} />
        <Route path='/tarifs' component={Tarifs} />
        <Route path='/contact' component={Contact} />



      </Switch>
    </div>
  );
}

export default App;